//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch('/cart/add.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 };
function changeProduct(formData) {
    return fetch('/cart/change.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

// ga4 view cart
dataLayer.push({ecommerce: null});
dataLayer.push({
    event: "view_cart",
    ecommerce: {
        value: cart.total_price / 100,
        currency: Shopify.currency.active,
        items: cart.items.map(function (item) {
            return {
                'item_name': item.product_title,
                'item_id': item.product_id,
                'item_variant': item.variant_title,
                'price': item.final_price / 100,
                'quantity': item.quantity
            }
        }),
        subscription: cart.items.filter(item => item.selling_plan_allocation != null).length > 0
    }
});

// upgrade to subscription
document.querySelectorAll(".cartBodyItemSwitchSave").forEach(function (element) {
    element.addEventListener("click", async function () {
        let cartBodyItem = this.closest(".cartBodyItem");

        // check if this is already checked
        if (this.classList.contains("active")) {
            // mark checkbox as inactive
            this.classList.remove("active");

            // show original pricing
            cartBodyItem.querySelectorAll("[data-original_price]").forEach(element => {
                element.textContent = price(element.dataset["original_price"]);
            });

            // hide the savings containers
            cartBodyItem.querySelectorAll('.cartBodyItemPriceSavings, .cartBodyItemPriceSavingsMobile').forEach(item => item.classList.remove("active"));
        } else {
            // mark checkbox as active
            this.classList.add("active");

            // show discount pricing
            cartBodyItem.querySelectorAll("[data-discount_price]").forEach(element => {
                element.textContent = price(element.dataset["discount_price"]);
            });

            // show the savings containers
            cartBodyItem.querySelectorAll('.cartBodyItemPriceSavings, .cartBodyItemPriceSavingsMobile').forEach(item => item.classList.add("active"));
        }

        updateSubtotal();
    });
});

// tissue add
document.querySelector("#cartBodyUpsellCheckbox")?.addEventListener("click", async function () {
    // check if this is already checked
    if (this.classList.contains("active")) {
        // mark checkbox as inactive
        this.classList.remove("active");
    } else {
        // mark checkbox as active
        this.classList.add("active");
    }

    updateSubtotal();
});

// update subtotal price
function updateSubtotal() {
    let subtotal = 0;
    document.querySelectorAll(".cartBodyItem").forEach(function (element) {
        // check if we use the discount price or not
        if (element.querySelector(".cartBodyItemSwitchSave.active")) {
            subtotal += parseInt(element.querySelector(".cartBodyItemTotal").dataset["discount_price"]);
        } else {
            subtotal += parseInt(element.querySelector(".cartBodyItemTotal").dataset["original_price"]);
        }
    });
    // check for tissues
    if (document.querySelector("#cartBodyUpsellCheckbox.active")) {
        subtotal += parseInt(document.querySelector("#cartBodyUpsellCheckbox.active").dataset.total);
    }
    document.querySelector("#cartFooterSubtotal span:last-child").textContent = price(subtotal);
}


document.querySelector("#cartFooterCheckout")?.addEventListener("click", async function (e) {
    e.preventDefault();

    // add loading
    this.classList.add("loading");

    // update each line item for subscription upgrades
    let itemElements = document.querySelectorAll(".cartBodyItem");
    for (let i = 0; i < itemElements.length; i++) {
        let element = document.querySelectorAll(".cartBodyItem")[i];

        // only update line items that are being upgrade to subscription
        if (element.querySelector(".cartBodyItemSwitchSave.active")) {
            let item = JSON.parse(element.getAttribute("item"));
            let sellingPlan = parseInt(element.querySelector(".cartBodyItemSwitchDropdown").value);

            // remove old product
            await changeProduct({
                id: item.key,
                selling_plan: sellingPlan,
                properties: {
                    "_upsell": true
                }
            });

            // ga data
            let ecommerceData = {
                value: cart.total_price / 100,
                currency: Shopify.currency.active,
                items: [
                    {
                        item_id: item.product_id,
                        item_name: item.product_title,
                        item_variant: item.variant_title,
                        price: item.price / 100,
                        quantity: item.quantity,
                        upsell: true
                    }
                ],
                subscription: true,
            };

            // fire ga
            dataLayer.push({ecommerce: null});
            dataLayer.push({
                event: "add_to_cart_link",
                ecommerce: ecommerceData
            });
            dataLayer.push({
                event: "cart_upsell",
                ecommerce: ecommerceData,
            });
        }
    }

    // add tissue if needed
    if (document.querySelector("#cartBodyUpsellCheckbox.active")) {
        await addProduct({
            quantity: 1,
            id: parseInt(document.querySelector("#cartBodyUpsellCheckbox.active").dataset.variant),
            properties: {
                "_upsell": true
            }
        });
    }

    // redirect
    window.location.href = "/checkout";

    // remove loading
    setTimeout(() => {
        this.classList.remove("loading");
    }, 250);

})